import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Book, FileText, Presentation } from 'lucide-react';
export function Publications() {
  const categories = [{
    icon: <Lightbulb size={32} data-id="element-386" />,
    title: 'Patents',
    id: 'patents'
  }, {
    icon: <Book size={32} data-id="element-387" />,
    title: 'Books',
    id: 'books'
  }, {
    icon: <FileText size={32} data-id="element-388" />,
    title: 'Journal Papers',
    id: 'journals'
  }, {
    icon: <Presentation size={32} data-id="element-389" />,
    title: 'Conference Papers',
    id: 'conferences'
  }];
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-390">
      {/* Hero with background */}
      <div className="relative bg-[#4A0000] py-24 text-center overflow-hidden" data-id="element-391">
        <div className="absolute inset-0 opacity-20" data-id="element-392">
          <img src="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&q=80&w=1200" alt="Books" className="w-full h-full object-cover" data-id="element-393" />
        </div>
        <div className="relative z-10" data-id="element-394">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-bold text-white font-serif mb-12" data-id="element-395">
            Publications
          </motion.h1>

          <div className="flex flex-wrap justify-center gap-6 max-w-4xl mx-auto px-4" data-id="element-396">
            {categories.map((cat, idx) => <a href={`#${cat.id}`} key={idx} className="bg-white rounded-full w-32 h-32 flex flex-col items-center justify-center text-[#800000] hover:scale-105 transition-transform shadow-xl" data-id="element-397">
                {cat.icon}
                <span className="mt-2 font-bold text-sm text-gray-900" data-id="element-398">
                  {cat.title}
                </span>
              </a>)}
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-24 space-y-24" data-id="element-399">
        {/* Patents */}
        <section id="patents" data-id="element-400">
          <div className="flex items-center gap-4 mb-8" data-id="element-401">
            <div className="h-px bg-[#800000] flex-grow" data-id="element-402"></div>
            <h2 className="text-3xl font-bold text-gray-900 font-serif" data-id="element-403">
              Patents
            </h2>
            <div className="h-px bg-[#800000] flex-grow" data-id="element-404"></div>
          </div>
          <ul className="space-y-6 list-decimal list-inside text-gray-700 leading-relaxed" data-id="element-405">
            <li data-id="element-406">
              LK Malla, DT Vempeny, D Praveen, H Dileep, PS Mahapatra, A
              Pattamatta, "A super wettable flat pulsating heat pipe based
              cooling device", Indian Patent No. 511897, 2023.
            </li>
            <li data-id="element-407">
              D Praveen, H Dileep, LK Malla, PS Mahapatra, A Pattamatta, "A kind
              of integrated two-phase heat spreader heat sink", Indian Patent
              No. 468268, 2023.
            </li>
            <li data-id="element-408">
              Purbarun Dhar, Ajay Katiyar, A. Pattamatta and Sarit K. Das.,
              "Graphene Nanoflakes Based Polymeric Pastes/Gels for
              Mega-Electroviscous Utilities", Indian Patent No. 352112, 2015.
            </li>
            <li data-id="element-409">
              A. Pattamatta and Ghanshyam Singh "A heat exchanger tube", IPC:
              F28F13/12, 2012.
            </li>
          </ul>
        </section>

        {/* Books */}
        <section id="books" data-id="element-410">
          <div className="flex items-center gap-4 mb-8" data-id="element-411">
            <div className="h-px bg-[#800000] flex-grow" data-id="element-412"></div>
            <h2 className="text-3xl font-bold text-gray-900 font-serif" data-id="element-413">
              Books
            </h2>
            <div className="h-px bg-[#800000] flex-grow" data-id="element-414"></div>
          </div>
          <ul className="space-y-6 list-decimal list-inside text-gray-700 leading-relaxed" data-id="element-415">
            <li data-id="element-416">
              <strong data-id="element-417">
                Essential Convective Heat Transfer - Theory & Applications
              </strong>{' '}
              published by Ane Books Pvt.Ltd, 2025
            </li>
            <li data-id="element-418">
              <strong data-id="element-419">
                Fundamentals of Nano- and Microscale Heat Transport
              </strong>
              , published by Springer, 2025
            </li>
          </ul>
        </section>
      </div>
    </div>;
}